import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, unref as _unref, toDisplayString as _toDisplayString, withKeys as _withKeys, normalizeClass as _normalizeClass, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createBlock as _createBlock } from "vue"
import _imports_0 from '@/assets/open-mdx.png'
import _imports_1 from '@/assets/logo-nepen.png'


const _hoisted_1 = { class: "align-center bg- flex !h-screen !w-screen items-center justify-center bg-[linear-gradient(33deg,rgba(26,174,232,1)_0%,rgba(109,197,232,1)_50%,rgba(207,240,255,1)_100%)]" }
const _hoisted_2 = { class: "h-fit w-11/12 rounded-xl bg-[rgba(255,255,255,0.5)] p-8 shadow backdrop-blur-md sm:w-10/12 md:w-[420px] md:p-12" }
const _hoisted_3 = { class: "text-sky-900" }
const _hoisted_4 = { class: "mb-2 block font-bold" }
const _hoisted_5 = {
  key: 0,
  class: "text-red-500"
}
const _hoisted_6 = { class: "mt-4 block font-bold" }
const _hoisted_7 = { class: "relative w-full" }
const _hoisted_8 = {
  key: 1,
  class: "text-red-500"
}
const _hoisted_9 = { class: "my-4" }
const _hoisted_10 = { class: "mt-4 flex flex-col items-center justify-center gap-4" }

import RecoverPassword from '@/components/login/RecoverPassword.vue'
import Icons from '@/components/subcomponents/Icons.vue'
import SelectLanguage from '@/components/subcomponents/SelectLanguage.vue'
import { resetUnauthenticatedState } from '@/composables/unauthenticatedToast'
import * as loginServices from '@/services/userService'
import { useLanguageStore } from '@/stores/LanguageStore'
import { useLoginValidator } from '@/validators/loginValidator'
import { useToast } from 'primevue'
import Button from 'primevue/button'
import InputText from 'primevue/inputtext'
import Tag from 'primevue/tag'
import { reactive, ref } from 'vue'
import { useRouter } from 'vue-router'


export default /*@__PURE__*/_defineComponent({
  __name: 'Login',
  setup(__props) {

const languageStore = useLanguageStore()
const toast = useToast()
const router = useRouter()

const { createForm, createEmptyErrors, normalizeCredential, validateAdForm, validateLocalForm } = useLoginValidator()

const form = reactive(createForm())
const errors = reactive(createEmptyErrors())
const isLoading = ref(false)
const showPassword = ref('password')
const passwordIcon = ref('eye-closed')
const errorMessage = ref('')

const handlePassword = () => {
  showPassword.value = showPassword.value === 'password' ? 'text' : 'password'
  passwordIcon.value = passwordIcon.value === 'eye-closed' ? 'eye-open' : 'eye-closed'
}

const login = () => {
  const validation = validateLocalForm(form)
  Object.assign(errors, validation.errors)
  if (!validation.isValid) {
    return
  }

  const normalizedEmail = normalizeCredential(form.email)

  isLoading.value = true
  errorMessage.value = ''

  loginServices
    .login(normalizedEmail, form.password)
    .then((res) => {
      resetUnauthenticatedState()
      const access = loginServices.auth(router, res.data.accessToken, res.data.user)
      if (!access) {
        errorMessage.value = 'Usuário não tem acesso a esta aplicação'
      }
    })
    .catch((error) => {
      errorMessage.value = error?.response?.data?.detail
      toast.add({
        summary: 'Erro',
        detail: errorMessage.value || 'Erro ao fazer login',
        severity: 'error',
        life: 3000,
      })
    })
    .finally(() => {
      isLoading.value = false
    })
}

const loginAd = () => {
  const validation = validateAdForm(form)
  Object.assign(errors, validation.errors)
  if (!validation.isValid) {
    return
  }

  const normalizedUsername = normalizeCredential(form.email)

  isLoading.value = true
  errorMessage.value = ''

  loginServices
    .loginAd(normalizedUsername, form.password, null)
    .then((res) => {
      const access = loginServices.auth(router, res.data.accessToken, res.data.user)
      if (!access) {
        errorMessage.value = 'Usuário não tem acesso a esta aplicação'
      }
    })
    .catch((error) => {
      errorMessage.value = error?.response?.data?.detail
      if (errorMessage.value === 'UserNotAssociated') {
        router.push({
          name: 'Associate',
          state: { ...form, email: normalizedUsername },
        })
        return
      }

      toast.add({
        summary: 'Erro',
        detail: errorMessage.value || 'Erro ao fazer login',
        severity: 'error',
        life: 3000,
      })
    })
    .finally(() => {
      isLoading.value = false
    })
}

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _cache[3] || (_cache[3] = _createElementVNode("div", { class: "mb-4 flex items-center justify-center gap-4" }, [
        _createElementVNode("img", {
          src: _imports_0,
          alt: "logo openmdx",
          class: "h-18 w-auto"
        })
      ], -1)),
      _createElementVNode("div", _hoisted_3, [
        _createElementVNode("label", _hoisted_4, _toDisplayString(_unref(languageStore).t('auth.login.emailLabel')), 1),
        _createVNode(_unref(InputText), {
          id: "email",
          type: "text",
          placeholder: _unref(languageStore).t('auth.login.placeholders.email'),
          onKeydown: _withKeys(login, ["enter"]),
          modelValue: form.email,
          "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((form.email) = $event)),
          class: _normalizeClass([{ 'p-invalid': errors.email }, "w-full"])
        }, null, 8, ["placeholder", "modelValue", "class"]),
        (errors.email)
          ? (_openBlock(), _createElementBlock("small", _hoisted_5, _toDisplayString(errors.email), 1))
          : _createCommentVNode("", true),
        _createElementVNode("label", _hoisted_6, _toDisplayString(_unref(languageStore).t('auth.login.passwordLabel')), 1),
        _createElementVNode("div", _hoisted_7, [
          _createVNode(_unref(InputText), {
            id: "password",
            type: showPassword.value,
            placeholder: _unref(languageStore).t('auth.login.placeholders.password'),
            class: _normalizeClass([{ 'p-invalid': errors.password }, "w-full pr-10"]),
            modelValue: form.password,
            "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((form.password) = $event)),
            onKeydown: _withKeys(login, ["enter"])
          }, null, 8, ["type", "placeholder", "class", "modelValue"]),
          _createVNode(Icons, {
            icon: passwordIcon.value,
            size: 24,
            class: "absolute right-3 top-1/2 -translate-y-1/2 cursor-pointer text-gray-400",
            onClick: handlePassword
          }, null, 8, ["icon"])
        ]),
        (errors.password)
          ? (_openBlock(), _createElementBlock("small", _hoisted_8, _toDisplayString(errors.password), 1))
          : _createCommentVNode("", true)
      ]),
      _createElementVNode("div", _hoisted_9, [
        _createVNode(RecoverPassword)
      ]),
      _createVNode(_unref(Button), {
        label: _unref(languageStore).t('auth.login.submitButtonAd'),
        class: "mb-2 w-full",
        onClick: loginAd,
        loading: isLoading.value
      }, null, 8, ["label", "loading"]),
      _createVNode(_unref(Button), {
        label: _unref(languageStore).t('auth.login.submitButton'),
        outlined: "",
        class: "w-full",
        onClick: login,
        loading: isLoading.value
      }, null, 8, ["label", "loading"]),
      (errorMessage.value)
        ? (_openBlock(), _createBlock(_unref(Tag), {
            key: 0,
            severity: "danger",
            value: errorMessage.value,
            class: "mt-4 w-full"
          }, null, 8, ["value"]))
        : _createCommentVNode("", true),
      _createElementVNode("div", _hoisted_10, [
        _cache[2] || (_cache[2] = _createElementVNode("img", {
          src: _imports_1,
          alt: "logo nepen",
          class: "h-8 w-auto"
        }, null, -1)),
        _createVNode(SelectLanguage, { opacity: 0.4 })
      ])
    ])
  ]))
}
}

})